import { Component, Input, AfterViewInit } from '@angular/core';


@Component({
  selector: 'app-escola-lista',
  templateUrl: './escola-lista.component.html',
  styleUrls: ['./escola-lista.component.css']
})
export class EscolaListaComponent implements AfterViewInit {
  @Input() public escolaList: any[] = [];
  @Input() public loading: boolean = true;

  constructor() { }

  ngAfterViewInit() {
    const divDados = document.getElementById('data-lista-escolas');
    if (divDados) {
      const targetContainer = document.getElementById('div-lista-escolas');
      if (targetContainer) {
        targetContainer.appendChild(divDados);
      }
    } else {
      window.location.reload();
    }
  }
}